// extracted by mini-css-extract-plugin
export default {"additionalInformationDataWrapper":"CartAdditionalInformation_additionalInformationDataWrapper__MKE1i"};